// BLOG POST: https://overreacted.io/making-setinterval-declarative-with-react-hooks

import { useEffect, useRef } from 'react';

export type UseIntervalCallback = () => void;

export const useInterval = (
  callback: UseIntervalCallback,
  delay: number | null,
) => {
  const savedCallback = useRef<UseIntervalCallback>();

  // Remember the latest callback.
  useEffect(() => {
    savedCallback.current = callback;
  }, [callback]);

  // Set up the interval.
  useEffect(() => {
    function tick() {
      savedCallback.current?.();
    }
    if (delay !== null) {
      const id = setInterval(tick, delay);
      return () => clearInterval(id);
    }
  }, [delay]);
};
